const getters = {
  permission_routes: state => state.permission.routes,
  openid: state => state.wxuser.openid
}

export default getters
